import { useEffect, useState } from 'react';
import { isOnline, subscribeNetworkStatus } from '../services/offline/networkStatus';

// Estado Online/Offline reutilizable. La lógica real vive en
// services/offline/networkStatus.js (no atada a React); este hook solo la
// expone como estado de componente.
export function useNetworkStatus() {
  const [online, setOnline] = useState(isOnline());

  useEffect(() => {
    return subscribeNetworkStatus(setOnline);
  }, []);

  return online;
}
